import React from 'react';
import { inject, observer } from 'mobx-react';
import MeetingModal, { MODE } from '@/models/meeting';
import RTCInstanceModal from '@/models/rtc';
import Grid from './Grid/index';
import Lecturer from './Lecture/index';
import ViewPanelH5 from '../ViewPanelH5';
import Reconnect from './Reconnect';
import FocusedView from './FocusedView';
import { useSwapSpeakWeight } from '../../hooks/useSwapWeight';

interface MeetingProps {
  meeting?: MeetingModal;
  rtc?: RTCInstanceModal;
  className?: string;
}

const Meeting: React.FC<MeetingProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    rtc: store.rtc,
  };
})(
  observer((props) => {
    const { meeting, rtc, className } = props;
    useSwapSpeakWeight();

    return (
      <div className={className}>
        {!rtc?.breakLineReconnecting && meeting?.viewMode === MODE.GRID && <Grid />}
        {!rtc?.breakLineReconnecting && meeting?.viewMode === MODE.LECTURER && <Lecturer />}
        <Reconnect show={!!rtc?.breakLineReconnecting} />
      </div>
    );
  })
);

export default window.isMobile ? ViewPanelH5 : Meeting;
